<script>
    import { recoveryFile, deleteFile } from '@/api/file.js';

    export default {
        props: {
            file: Object,
            functionUpdatePage: Function,
        },
        computed: {
            assetTypeID() { return this.$store.getters.ASSET_TYPE_IMAGES },
        },
        methods: {
            async delFile() {
                const response = await deleteFile(this.assetTypeID, this.file.id);
                if (response === true) {
                    this.assetType = await this.$store.commit('IMAGE_DELETE_BY_ID', this.file.id);
                    this.functionUpdatePage();
                }
            },
            async recFile() {
                const response = await recoveryFile(this.assetTypeID, this.file.id);
                if (response === true) this.file.setActiveStatus(true);
            }
        }
    }
</script>


<template>
    <div class="image_header_disable">
        <button 
            class="button_blue_150 red_color"
            @click="recFile"
        >Recovery</button>
        <!-- A gup row is erased for good from the sticky Delete, never just binned. -->
        <button
            v-if="file['origin'] === 'gup'"
            type="button"
            :aria-pressed="file['toDelete'] === true"
            :class="file['toDelete'] === true ? 'ml_10 to_delete to_delete_on' : 'ml_10 to_delete'"
            title="Mark for erase: off the shelves, out of S3 and the database, and GUP won't upload it again"
            @click="file.toggleToDelete()"
        >{{ file['toDelete'] === true ? '☒' : '☐' }} To deletion</button>
        <button
            v-else
            class="button_blue_150 red_color ml_10"
            @click="delFile"
        >Delete</button>
        <div class="ihd_resolution ml_10">
            <label>{{ file['resolution'] }}</label>
        </div>
        <div class="ihd_label">
            <label>[{{ file['id'] }}]</label>
            <label class="ml_5">{{ file['name'] }}</label>
        </div>
    </div>
</template>


<style scoped>
    .image_header_disable {
        display: flex;
        flex-direction: row;
        padding: 5px;
    }
    .image_header_disable > button {
        flex: 0 0 150px;
    }
    .ihd_resolution {
        flex: 0 0 150px;
        width: 150px;

        background-color: var(--background);
        /* border-left: 2px solid #ffffff; */
        /* border-right: 2px solid #ffffff; */
        border-radius: 5px;

        text-align: center;
    }
    .ihd_label {
        flex: 1 1 100%;
        text-align: center;
    }

    .red_color {
        background-color: #fc424a;
    }
    .red_color:hover {
        background-color: #fd696f;
    }
    /* 869fhgjpg: the mark for the sticky Delete above the list. */
    .to_delete {
        flex: 0 0 150px;
        border: 1px solid #fc424a;
        border-radius: 5px;
        background-color: transparent;
        color: inherit;
        cursor: pointer;
    }
    .to_delete_on {
        background-color: #fc424a;
        color: #ffffff;
    }
</style>